//
// Copyright 2023 DXOS.org
//
import { create } from '@bufbuild/protobuf';
import { ErrorSchema } from '../buf/proto/gen/dxos/error_pb.js';
import { reconstructError } from './helpers.js';
/** Bounds the cause chain folded into a serialized stack. */
const MAX_CAUSE_DEPTH = 8;
/**
 * The wire format has no `cause` field, so the chain is folded into the stack, where a remote
 * failure's origin (e.g. the SQLite error beneath a host-side `SqlError`) is otherwise lost.
 */
const stackWithCauses = (err) => {
    const parts = [err.stack ?? `${err.name}: ${err.message}`];
    const seen = new Set([err]);
    let cause = err.cause;
    while (cause !== undefined && cause !== null && !seen.has(cause) && parts.length <= MAX_CAUSE_DEPTH) {
        seen.add(cause);
        const described = cause instanceof Error ? (cause.stack ?? `${cause.name}: ${cause.message}`) : String(cause);
        // `toServiceError` wraps a foreign error under its own stack, which would otherwise print twice.
        if (described !== parts.at(-1)) {
            parts.push(described);
        }
        cause = cause instanceof Error ? cause.cause : undefined;
    }
    return parts.length === 1 ? err.stack : parts.join('\nCaused by: ');
};
export const encodeError = (err) => {
    if (typeof err === 'object' && err?.message) {
        return create(ErrorSchema, {
            name: err.name,
            message: err.message,
            context: err.context,
            stack: err instanceof Error ? stackWithCauses(err) : err.stack,
        });
    }
    else if (typeof err === 'string') {
        return create(ErrorSchema, { message: err });
    }
    else {
        return create(ErrorSchema, { message: JSON.stringify(err) });
    }
};
export const decodeError = (err, { appendStack } = {}) => {
    const error = reconstructError(err);
    if (appendStack) {
        error.stack = (err.stack ?? `${error.message}\n`) + appendStack;
    }
    else {
        error.stack = err.stack;
    }
    return error;
};
//# sourceMappingURL=encoding.js.map